import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

interface CategoryNavProps {
  activeSlug?: string;
}

export default function CategoryNav({ activeSlug }: CategoryNavProps) {
  return (
    <section className="py-8 md:py-10">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-6 gap-3 md:gap-4">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`group flex flex-col items-center gap-2 p-4 md:p-5 rounded-xl transition-all duration-300 cursor-pointer ${
                  activeSlug === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 hover:bg-background-200 text-foreground-700'
                }`}
              >
                <div className={`w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center transition-colors ${
                  activeSlug === cat.slug
                    ? 'bg-background-50/20'
                    : 'bg-background-200 group-hover:bg-background-300'
                }`}>
                  <i className={`${cat.icon} text-lg md:text-xl ${
                    activeSlug === cat.slug ? 'text-background-50' : 'text-foreground-700'
                  }`}></i>
                </div>
                <span className="text-sm font-medium whitespace-nowrap">{cat.name}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}